import { defaultHelpMeNowQuestion, defaultProactiveSuggestionInterval, type TimelineFeatures } from "@expert/features";

import { env } from "./env";

export const envName = env.envName;
export const isProd = env.isProd;

export const timelineFeatures: TimelineFeatures = {
    helpMeNowQuestion: defaultHelpMeNowQuestion,
    isChatExpertAssistAutoCompleteEnabled: false,
    isChatProactiveSuggestionsEnabled: false,
    isGuidedFlowRecommendationEnabled: false,
    isHelpMeNowEnabled: false,
    isOzmoIFrameEnabled: false,
    isProactiveGuidanceEnabled: false,
    isProactiveEnabled: false,
    isSalesFAQEnabled: false,
    isGroundedSearchExperimentEnabled: false,
    proactiveSuggestionInterval: defaultProactiveSuggestionInterval,
};
